type LeaguePositionType = 'gold' | 'silver' | 'bronze' | 'default' | 'other';

type LeaguePositionLabelType =
  | 'gold'
  | 'silver'
  | 'bronze'
  | 'default'
  | string;

const leaguePostionName: Record<number, 'gold' | 'silver' | 'bronze'> = {
  1: 'gold',
  2: 'silver',
  3: 'bronze',
};

const getChestKindByLeaguePosition = (
  position?: number,
): LeaguePositionType | undefined => {
  if (position) {
    return position in leaguePostionName
      ? leaguePostionName[position as keyof typeof leaguePostionName]
      : position < 16
        ? 'default'
        : 'other';
  }
};

const getPositionLabelByLeaguePosition = (
  position?: number,
): LeaguePositionLabelType | undefined => {
  if (position) {
    return position in leaguePostionName
      ? leaguePostionName[position as keyof typeof leaguePostionName]
      : position < 21
        ? 'default'
        : String(position);
  }
};

export { getChestKindByLeaguePosition, getPositionLabelByLeaguePosition };
